import * as React from 'react'

import * as api from '@owl-nest/api-client/latest'
import { useAwait, AwaitStatus } from '@owl-nest/hooks'
import { useOnboardingStep } from '../Onboarding/useOnboardingStep'

export type Project = api.Project<'onboarding_steps'>

export type Rule = (steps: { [s: string]: any }, setStep: SetStep) => Promise<React.ReactNode | undefined>

type SetStep = (name: string, value: any) => Promise<any>

export function useLilSam<PROJECT extends Project>(
  namespace: string,
  project: PROJECT,
  rule: Rule,
  dependencies: any[],
  updateSteps: (onboarding_steps: any) => Promise<any>,
): React.ReactNode {
  const currentSteps = project?.onboarding_steps?.[namespace] || {}
  const setOnboardingStep = useOnboardingStep({ project, namespace, setOnboardingSteps: updateSteps })
  const rulePromise = React.useMemo(() => rule(currentSteps, setOnboardingStep), dependencies)
  const awaited = useAwait(rulePromise)

  if (awaited.status === AwaitStatus.SUCCESS) {
    return awaited.success
  }

  return undefined
}
